import { api, ApiError } from "../api.js";
import { h } from "../ui.js";
import { pixelMark, type App } from "../main.js";

/** Pre-sign-in: logo, era badge, email → code. Nothing else (platform spec §4.1). */
export function loginView(app: App): HTMLElement {
  let email = "";
  let stage: "email" | "code" = "email";
  let message: HTMLElement | null = null;

  const emailInput = h("input", { class: "input", type: "email", name: "email", autocomplete: "email", inputmode: "email", placeholder: "you@example.com", required: true, autofocus: true });
  const codeInput = h("input", { class: "input code", type: "text", name: "code", inputmode: "numeric", pattern: "[0-9]{6}", maxlength: "6", autocomplete: "one-time-code", placeholder: "······" });
  const submit = h("button", { class: "btn primary", type: "submit" }, "Send code");
  const msgSlot = h("div");
  const codeField = h("div", { class: "field", hidden: true }, h("label", { for: "code" }, "6-digit code"), codeInput);

  const setMsg = (text: string, kind: "error" | "ok" | "") => {
    message = h("div", { class: `msg ${kind}` }, text);
    msgSlot.replaceChildren(message);
  };

  const form = h("form", {
    onsubmit: async (e: Event) => {
      e.preventDefault();
      submit.disabled = true;
      try {
        if (stage === "email") {
          email = emailInput.value.trim();
          const r = await api.requestCode(email);
          stage = "code";
          codeField.hidden = false;
          emailInput.readOnly = true;
          submit.textContent = "Sign in";
          setMsg(r.devCode ? `Dev mode — your code is ${r.devCode}` : `Code sent to ${email}. Check your inbox.`, "ok");
          codeInput.focus();
        } else {
          await api.verify(email, codeInput.value.trim(), app.isLauncher ? "launcher" : navigator.userAgent.slice(0, 48));
          app.go("/home");
        }
      } catch (err) {
        setMsg(err instanceof ApiError ? err.message : "Something went wrong", "error");
      } finally {
        submit.disabled = false;
      }
    },
  },
    h("div", { class: "field" }, h("label", { for: "email" }, "Email"), emailInput),
    codeField,
    msgSlot,
    submit,
    h("p", { class: "dim", style: "font-size:11px" }, "No password. We email you a code each time; this device stays signed in for 30 days."),
  );

  return h("div", { class: "login" },
    h("div", { class: "stack", style: "align-items:center; gap: var(--u3)" },
      h("div", { class: "signal", "aria-hidden": "true" }),
      h("div", { class: "logo" }, pixelMark(), "Bit Depth"),
      h("span", { class: "badge" }, "pre-alpha"),
      h("p", { class: "tag" }, "One dungeon. Everyone descends it together."),
    ),
    form,
    h("p", { class: "dim mono-num", style: "font-size:11px" }, `build ${app.build} · ${app.channel}`),
  );
}
